import React, {FC} from 'react';
import styled from 'styled-components';

import {Plural, Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {UserThemeConsumer} from '../../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {getChannelIconName} from '../../../../../helpers/channelViewHelpers';
import {buildChannelDisplayName} from '../../../../../helpers/models/channelHelpers';
import {ChannelModel} from '../../../../../models/api/channelModel';
import {StyledCountSpan, StyledGridContentDiv, StyledIconDiv} from './conversationSummaryCommonStyles';
import {
  ConversationSummaryDetailsSubsection,
  StyledDetailsSubsectionListDiv,
} from './conversationSummaryDetailsSubsection';

/*
 * Styles.
 */

const StyledChannelsListDiv = styled(StyledDetailsSubsectionListDiv)`
  grid-row-gap: 9px;
`;

/*
 * Component.
 */

export const ConversationSummaryChannels: FC<{channels: ReadonlyArray<ChannelModel>}> = ({channels}) => {
  if (channels.length === 0) {
    return null;
  }

  return (
    <ConversationSummaryDetailsSubsection
      title={renderChannelsTitle(channels)}
      content={renderChannelsContent(channels)}
    />
  );
};

function renderChannelsContent(channels: ReadonlyArray<ChannelModel>) {
  return <StyledChannelsListDiv>{channels.map(renderChannel)}</StyledChannelsListDiv>;
}

function renderChannelsTitle(channels: ReadonlyArray<ChannelModel>) {
  return (
    <Plural
      value={channels.length}
      one={<Trans id="conversation-summary-channel">Channel</Trans>}
      other={
        <>
          <Trans id="conversation-summary-channels">Channels</Trans>
          <StyledCountSpan>({channels.length})</StyledCountSpan>
        </>
      }
    />
  );
}

function renderChannel(channel: ChannelModel) {
  const iconName = getChannelIconName(channel.contactSource);
  return (
    <UserThemeConsumer key={channel.id}>
      {(theme) => (
        <>
          <StyledIconDiv>
            <Icon name={iconName} color={theme.greys.shade50} />
          </StyledIconDiv>
          <StyledGridContentDiv>{buildChannelDisplayName(channel)}</StyledGridContentDiv>
        </>
      )}
    </UserThemeConsumer>
  );
}
